import {AbstractVisualFeature} from '../../visual-feature.js';
import {Interface} from '../interface.js';

import {breadcrumbsFactory} from './breadcrumbs.factory.js';

import PALETTE_SCHEMA from './breadcrumbs.palette-schema.yaml';

class BreadcrumbsFeature extends AbstractVisualFeature {
    get name() {
        return 'Breadcrumbs';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return breadcrumbsFactory(PALETTE);
    }
}

new BreadcrumbsFeature(Interface);
